import req from './request'

export const getAbout = _ => req.get('/index/about')
export const getJob = _ => req.get('/index/contactus')
export const getWorldView = _ => req.get('/index/worldview')
export const getHome = _ => req.get('/index/homepage')
export const getNews = _ => req.get('/index/news')
export const getProject = _ => req.get('/index/projectintro')
export const getLive = _ => req.get('/index/live')
export const pvLive = p => req.post('/index/live/pv', p)
export const pvNews = p => req.post('/index/news/pv', p)

export const getYl = id => req(`/index/news/preview?id=${id}`)
export const wvYl = id => req(`/index/worldview/preview?id=${id}`)
export const projectYl = id => req(`/index/projectintro/preview?id=${id}`)
export const homeYl = id => req(`/index/homepage/preview?id=${id}`)
export const aboutYl = id => req(`/index/about/preview?id=${id}`)
export const contactYl = id => req(`/index/contactus/preview?id=${id}`)
export const liveYl = id => req(`/index/live/preview?id=${id}`)



// WEBPACK FOOTER //
// ./src/utils/api.js